import { _ } from "ynf-core-middleware";
export enum precisionType  {
  ROUND= 'round',
  FLOOR= 'floor',
  CEIL= 'ceil'
}


export function getString(modelPath: Array<string>, sign?: string) {
  let rs = '';
  if (!sign) {
    sign = '.'
  }
  modelPath.forEach((item) => {
    rs += item + sign;
  })
  if (rs.length > sign.length) {
    rs = rs.substring(0, rs.length - sign.length);
  }
  return rs;
}
export function precisionMetrics(value: number | string, precision: number, precisionMethod?: string | Function) {
  if (typeof precisionMethod === 'function') {
    return precisionMethod(value, precision)
  } else if ((precision || precisionMethod || precision === 0) && value) {
    const valueHandler = precisionMethod === precisionType.FLOOR ? _.floor(value, precision) : precisionMethod === precisionType.CEIL ? _.ceil(value, precision) : _.round(value, precision);
    // 如果精度大于0，且value最后包含.，且为string
    return (precision > 0 && typeof value === 'string' && value.endsWith(".")) ? value: valueHandler
  } else {
    return value
  }
}

type ExcludeTypes = Function | RegExp | Date;

export class DeepCopyUtil {
  static deepCopyAndExcludeTypes<T extends object>(obj: T, excludeTypes: ExcludeTypes[]): Omit<T, keyof typeof excludeTypes> {
    const clone = DeepCopyUtil.deepCopy(obj, excludeTypes);
    return clone as Omit<T, keyof typeof excludeTypes>;
  }

  private static deepCopy<T extends object>(obj: T, excludeTypes: ExcludeTypes[]): T {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    const clone: any = Array.isArray(obj) ? [] : {};

    Object.keys(obj).forEach((key) => {
      const value = obj[key];

      if (DeepCopyUtil.shouldExcludeType(value, excludeTypes)) {
        return;
      }

      clone[key] = DeepCopyUtil.deepCopy(value, excludeTypes);
    });

    return clone;
  }

  private static shouldExcludeType(value: any, excludeTypes: ExcludeTypes[]): boolean {
    return excludeTypes.some((type) => value instanceof type);
  }
}